export const convertSentenceToSlug = (input: string) =>
  input.replaceAll(' ', '-').replaceAll('.', '').toLowerCase();
